import qs from 'qs-lite';
import { useQuery, useMutation, useQueryClient } from 'react-query';

import config from '@src/config';
import api from '@src/utils/api';
import {
  CAMPAIGN_SUBMISSIONS_LIST,
  CAMPAIGN_SUBMISSION_DETAILS,
} from '@src/hooks/react-query/queries';
import { useVpSnackbar } from '@vp-ui/hooks';

const fetchCampaignSubmissions = ({ queryKey }) => {
  const queryString = qs.stringify(queryKey[1]);

  return api.get(`/v1/campaign-submissions${queryString ? `?${queryString}` : ''}`);
};

//queries
export const useFetchCampaignSubmissions = () => {
  const {
    campaignIds,
    tagIds,
    contentTypes,
    categoryIds,
    limit = '25',
    offset = '0',
    searchParam,
    hasCaptions,
  } = qs.parse(window?.location?.search?.split('?')?.[1]) || {};

  const queryProps = {
    campaignIds,
    tagIds,
    contentTypes,
    categoryIds,
    limit,
    offset,
    searchParam,
    orderBy: 'created_at',
    sortOrder: 'DESC',
    ...(hasCaptions === 'true' && { hasCaptions: true }),
  };
  return useQuery([CAMPAIGN_SUBMISSIONS_LIST, { ...queryProps }], fetchCampaignSubmissions, {
    keepPreviousData: true,
  });
};

const fetchCampaignSubmissionByID = ({ queryKey }) => {
  const submissionId = queryKey[1];
  return api.get(`/v1/campaign-submissions/${submissionId}?includeDeleted=true`);
};
export const useFetchCampaignSubmissionByID = (submissionId) => {
  return useQuery([CAMPAIGN_SUBMISSION_DETAILS, submissionId], fetchCampaignSubmissionByID, {
    enabled: !!submissionId,
  });
};

const fetchCampaignSubmissionByIDPublic = ({ queryKey }) => {
  const submissionId = queryKey[1];
  return api.get(`/v1/campaign-submissions/public/${submissionId}?includeDeleted=true`);
};

export const useFetchCampaignSubmissionByIDPublic = (submissionId) => {
  const { addSnackbarError } = useVpSnackbar();
  return useQuery([CAMPAIGN_SUBMISSION_DETAILS, submissionId], fetchCampaignSubmissionByIDPublic, {
    enabled: !!submissionId,
    onError: (e) => {
      addSnackbarError({ title: e?.response?.data?.error, message: e?.response?.data?.message });
    },
  });
};

const deleteCampaignSubmission = (submissionId) => {
  return api.delete(`${config.endpoints.campaignSubmissions}/${submissionId}`);
};

export const useDeleteSubmission = () => {
  const queryClient = useQueryClient();

  return useMutation(deleteCampaignSubmission, {
    onSuccess: () => {
      queryClient.invalidateQueries(CAMPAIGN_SUBMISSIONS_LIST);
      queryClient.invalidateQueries(CAMPAIGN_SUBMISSION_DETAILS);
    },
  });
};

const createCampaignSubmission = (payload) => api.post('/v1/campaign-submissions', payload);
export const useCreateCampaignSubmission = () => {
  return useMutation(createCampaignSubmission);
};

const importCampaignSubmission = (payload) => api.post('/v1/campaign-submissions/import', payload);
export const useImportCampaignSubmission = () => {
  return useMutation(importCampaignSubmission);
};



// WEBPACK FOOTER //
// ./src/hooks/react-query/useSubmissionsData.js